import { Alert, Box, CircularProgress } from '@mui/material';
import { useEffect } from "react";
import { useAppNotification } from "../hooks/useFetchData";

const MessageSectionSubmit = ({ action, type, userId, data, disableNotification}) => {
  const { notificationStatus, notification, notificationError} = useAppNotification({
    endpoint: `/${type}/${action}AppNotification`,
    method: 'post',
    body: {
      notification: data,
      userId: userId
    }
  });

  useEffect(() => {
    if (notificationStatus === "resolved") {
      disableNotification(true);
    }
  });

  return (
    <>
      <Box sx={{ p: 2, m: 2, width: 500 }}>
        {notificationStatus === "loading" && <CircularProgress />}

        {notificationStatus === "resolved" && (
          <Alert variant="filled" severity="success">
            {`Successfully ${action}d Message`}
          </Alert>
        )}

        {(notificationStatus === "rejected" ||
          notificationStatus === "unauthorized") && (
          <Alert variant="filled" severity="error">
            {notificationError.data}
          </Alert>
        )}
      </Box>
    </>
  );

};

export default MessageSectionSubmit;
